export const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    (process.env.REACT_APP_FIREBASE_PROJECT_ID
      ? `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`
      : undefined),
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_ID,
};

export const stage = config.projectId === 'todesktop-prod1' ? 'prod' : 'dev';

export const webauthnServerUrl =
  stage === 'prod'
    ? 'https://webauthn.todesktop.cloud'
    : 'https://webauthn-staging.todesktop.cloud';

export const authEmulatorHost = process.env.REACT_APP_AUTH_EMULATOR_HOST;
export const firestoreEmulatorHost = process.env.REACT_APP_FIRESTORE_HOST;
export const functionsEmulatorHost = process.env.REACT_APP_FUNCTIONS_HOST;
export const apiEmulatorHost = process.env.REACT_APP_API_HOST;
